// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-gsrTeb","text":"text-cEIYZ2","box":"box-I9PYxZ"};